import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setOrderBy,setRowsPerPage} from 'reducers/paginationNTsSlice';
import { Link } from 'react-router-dom' 
import { useTranslation } from "react-i18next"
import Box from '@mui/material/Box'; 
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Paper from '@mui/material/Paper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme';
import visuallyHidden from '@mui/utils/visuallyHidden';
import mitecoIcon from "components/photos/sidebars/miteco.png";
import proccessIcon from "components/photos/sidebars/process.jpeg";
import errorIcon from "components/photos/sidebars/error.jpg";
import signIcon from "components/photos/sidebars/firmadigital.jpg";
import okIcon from "components/photos/sidebars/OK.jpg"; 
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsNT = [
  { id: 'number_nt', numeric: false, disablePadding: false, label: 'Text_NT_NUMBER', canOrder: true },
  { id: 'date_sheet', numeric: false, disablePadding: false, label: 'Text_NT_DATE', canOrder: true },
  { id: 'opt_tras_tradename', numeric: false, disablePadding: false, label: 'Text_FORM_ORI_TRAS', canOrder: true },
  { id: 'ori_tras_tradename', numeric: false, disablePadding: false, label: 'Text_FORM_DEST_TRAS', canOrder: true },
  { id: 'deliveryamount', numeric: false, disablePadding: false, label: 'Text_FORM_AMOUNT', canOrder: true }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t,showEmailButtonNT,showESIRButton,showESIRButtonSEND,showEditButtonNT,showPrintButtonNT,showDeleteButtonNT,showStoreNT,showUserAccountNT} = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {showEditButtonNT &&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonNT &&
          <TableCell
            key='print'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} >
              {t('Button_Print_PDF')}
            </Typography>
          </TableCell>
        }
        {showEmailButtonNT &&
          <TableCell
            key='email'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Print_EMAIL')}
            </Typography>
          </TableCell>
        }
        {showESIRButton &&
          <TableCell
            key='esir'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Text_MITECO')}
            </Typography>
          </TableCell>
        }
         {showESIRButtonSEND &&
          <TableCell
            key='esirsend'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Text_MITECO_SEND')}
            </Typography>
          </TableCell>
        }
        {headCellsNT.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}  
        {showStoreNT &&
          <TableCell
            key='tradename'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'tradename'}
              direction={orderBy === 'tradename' ? order : 'asc'}
              onClick={createSortHandler('tradename')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_Store_Create')}
                {orderBy === 'tradename' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        }
        {showUserAccountNT &&
          <TableCell
            key='username'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'username'}
              direction={orderBy === 'username' ? order : 'asc'}
              onClick={createSortHandler('username')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_UserAcount_Create')}
                {orderBy === 'username' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        } 
        {showDeleteButtonNT &&
          <TableCell
            key='delete'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} > 
              {t('Button_Delete')}
            </Typography>
          </TableCell>
        }
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegNT, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegNT).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataForms']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingNT =(props)=>{
  const { 
    dataNT, 
    numTotRegFilter,
    titleTable,
    setOpenDeleteRowNT,
    setOpenErrorRowNT,
    setRowEditNT,
    showEditButtonNT,
    showPrintButtonNT,
    showDeleteButtonNT,
    showEmailButtonNT,
    showESIRButton,
    showESIRButtonSEND,
    showStoreNT,
    showUserAccountNT,
    numTotRegNT,
    activeOffsetNT,
    rangeOffsetNT,
    currencyOffsetNT,
    setCurrencyOffsetNT,
    setViewPDF
  } = props;
  const {t,i18n} = useTranslation(['listDataForms']);
  const dispatch = useDispatch();
  const { currentPage, order, orderBy,rowsPerPage } = useSelector((state) => state.paginationNTs);
  const [countData,setCountData] = useState(dataNT.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataNT.length) : 0);
  
  useEffect(
    () => {
      setCountData(dataNT.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataNT.length) : 0);  
    },
    [dataNT,page,setEmptyRows,rowsPerPage,countData]
  );

  const handleChangeOffset = (event) => {
    setCurrencyOffsetNT(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
    dispatch(setOrderBy(property)); // Actualiza Redux
  };  

  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };

  const openModalDeleteRowNT = (row) => {
    setRowEditNT(row);
    setOpenDeleteRowNT(true);
  };

  const openModalFormDIPDF = async (row) => {
    setRowEditNT(row);
    setViewPDF(true);
  };

  const openModalERRORESIR = (row) => {
    setRowEditNT(row);
    setOpenErrorRowNT(true);
  };
 
  const listItems = stableSort(dataNT, getComparator(order, orderBy))
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((row, keyData) => {
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(showEditButtonNT && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link  to={`/ntdetail/${row.id}`} >
              <IconButton size="large" className="edit-icon-button">
                <EditIcon style={{ fontSize: 28 }} />
              </IconButton> 
            </Link>
          </TableCell>
        }
         {(showPrintButtonNT && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <IconButton size="large" className="print-icon-button" onClick={() => openModalFormDIPDF(row)}>
              <PictureAsPdfIcon style={{ fontSize: 28 }} />
            </IconButton> 
          </TableCell>
        }
        {(showEmailButtonNT && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link  to={`/ntsendemail/${row.id}`} >
              <IconButton size="large" className="email-icon-button" >
                <EmailIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Link>
          </TableCell>
        }
        {(showESIRButton && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            {(row.statussentesir==null || row.statussentesir==="" || row.statussentesir===0) ?
              <Link to={`/ntsendesirended/${row.id}`}>
              <IconButton size="small" className="btn-white-outline" aria-label="Enviar a e-SIR">
                <img src={mitecoIcon} alt="MITECO" className="btn-img" />
              </IconButton>
            </Link>:
            (row.statussentesir===1 ) ?
             <IconButton size="small" className="btn-white-disabled" aria-label="Procesando">
              <img src={proccessIcon} alt="En proceso" className="btn-img" />
            </IconButton> :
            (row.statussentesir===2 ) ?
              <IconButton
                size="small"
                className="btn-white-error"
                onClick={() => openModalERRORESIR(row)}
                aria-label="Error e-SIR"
              >
                <img src={errorIcon} alt="Error e-SIR" className="btn-img" />
              </IconButton>:
               <IconButton
                size="small"
                className="btn-white-success"
                onClick={() => openModalERRORESIR(row)}
                aria-label="Correcto e-SIR"
              >
                <img src={okIcon} alt="Correcto e-SIR" className="btn-img" />
              </IconButton> 
            }
          </TableCell> 
        }
        {(showESIRButtonSEND && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            {(row.statussentesir==null || row.statussentesir==="" || row.statussentesir===0) ?
              <Link to={`/ntsendesirendedcert/${row.id}`}>
                <IconButton size="small" className="btn-white-outline" aria-label="Enviar a e-SIR">
                  <img src={mitecoIcon} alt="MITECO" className="btn-img" />
                </IconButton> 
              </Link>:
              (row.statussentesir===1 || row.statussentesir===2) ?
                

                <Link to={`/ntsendesirendedcert/${row.id}`}>
                  <IconButton size="small" className="btn-white-success" aria-label="Procesando">
                    <img src={mitecoIcon} alt="En proceso" className="btn-img" />
                  </IconButton>
                </Link>:
                (row.statussentesir===3) ?
                  <Link to={`/ntsendesirendedcert/${row.id}`}>
                    <IconButton size="small" className="btn-white-outline" aria-label="Enviar a e-SIR">
                      <img src={signIcon} alt="e-sign" className="btn-img" />
                    </IconButton>  
                </Link>:
                <Link to={`/ntsendesirendedcert/${row.id}`}>
                  <IconButton size="small" className="btn-white-success" aria-label="Correcto e-SIR" >
                    <img src={okIcon} alt="e-OK" className="btn-img" />
                  </IconButton>  
                </Link> 
            }
          </TableCell> 
        }
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.number_nt}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.date_sheet!==""?new Date(row.date_sheet).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):""}
           </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.ori_tras_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.dest_tras_tradename}
          </Typography>
        </TableCell>   
        <TableCell align="left">
          {(() => {
            const used = Number(row.deliveryamount) || 0;
            const total = Number(row.amount) || 0;

            const percentage =
              total > 0 ? Math.min((used / total) * 100, 100) : 0;

            // Color dinámico REAL
            let colorClass = "green";
            if (percentage >= 85) colorClass = "red";
            else if (percentage >= 60) colorClass = "yellow";

            const formatKg = (value) =>
              value.toLocaleString("es-ES", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });

            return (
              <div className="emp-progress-wrapper">
                <Typography className="emp-progress-percent">
                  {percentage.toFixed(1)}%
                </Typography>
                <div className="emp-progress-bar">
                  <div
                    className={`emp-progress-fill ${colorClass}`}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
                <Typography className="emp-progress-amount">
                  {formatKg(used/1000)} Tn de {formatKg(total/1000)} Tn
                </Typography>
              </div>
            );
          })()}
        </TableCell>
        {showStoreNT  &&
            <TableCell align="left">
              <Typography style={{color:"#000000", fontSize: 16}} >
                {row.tradename}
              </Typography>  
            </TableCell>
        }
        {showUserAccountNT  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.username}
            </Typography>  
          </TableCell>
        } 
        {(showDeleteButtonNT && row.id!=="" && row.id!==null) &&
          <TableCell align="center">
            <IconButton size="large" className="delete-icon-button" onClick={() => openModalDeleteRowNT(row)} >
              <DeleteIcon style={{ fontSize: 28 }} />
            </IconButton> 
          </TableCell>}
        
      </TableRow>
    );
  });
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegNT={numTotRegNT} textOf={t('Text_Of')}/>
           <TableContainer component={Paper} className="formdi-table-container" sx={{ maxHeight: 1400 }}>
            <Table sx={{ minWidth: '800px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t} showEmailButtonNT={showEmailButtonNT} showESIRButton={showESIRButton} showESIRButtonSEND={showESIRButtonSEND} showEditButtonNT={showEditButtonNT} showPrintButtonNT={showPrintButtonNT} showDeleteButtonNT={showDeleteButtonNT} showStoreNT={showStoreNT} showUserAccountNT={showUserAccountNT} />
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={14} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetNT && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetNT"
                            name="currencyOffsetNT"
                            value={currencyOffsetNT}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetNT
                            }}>
                            {rangeOffsetNT.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={14}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingNT.propTypes = {
  dataNT: PropTypes.array.isRequired, 
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,
  setOpenDeleteRowNT: PropTypes.func.isRequired, 
  setOpenErrorRowNT: PropTypes.func.isRequired, 
  setRowEditNT: PropTypes.func.isRequired,     
  showEditButtonNT: PropTypes.bool.isRequired,  
  showESIRButton: PropTypes.bool.isRequired,
  showESIRButtonSEND: PropTypes.bool.isRequired,
  showPrintButtonNT: PropTypes.bool.isRequired,  
  showDeleteButtonNT: PropTypes.bool.isRequired,
  showEmailButtonNT: PropTypes.bool.isRequired,
  showStoreNT: PropTypes.bool.isRequired,
  showUserAccountNT: PropTypes.bool.isRequired, 
  activeOffsetNT: PropTypes.bool.isRequired,
  rangeOffsetNT: PropTypes.array.isRequired,
  currencyOffsetNT: PropTypes.number.isRequired,
  setCurrencyOffsetNT: PropTypes.func.isRequired,
  setViewPDF: PropTypes.func.isRequired 
};
  
export default TableSortingNT;
